import styled from 'styled-components';
import Color from 'color';

const PageContainer = styled.div`
  background-color: ${props => Color(props.theme.colors.gray).lighten(0.09).string()};
`;

export default PageContainer;
